import React from "react";

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex items-start justify-between border-b border-[#E5E7EB] pb-6 mb-8">
      <div>
        <h1 className="font-display text-4xl sm:text-5xl text-[#0F172A]">{title}</h1>
        {subtitle && <p className="text-neutral-600 mt-2 text-sm max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function PageContainer({ children }) {
  return <div className="p-6 md:p-10 max-w-[1400px] mx-auto anim-fade-up">{children}</div>;
}
